import { SplitFactory } from '@splitsoftware/splitio';
import * as SplitIO from '@splitsoftware/splitio/types/splitio';

import { TREATMENTS } from './toggles-definition';

const isServer = typeof window === 'undefined';
export interface ToggleFunction {
  isEnabled: () => boolean;
  getValue: () => string;
}

export const SplitFeatureToggles = (function () {
  let client: SplitIO.IClient;
  let factory: SplitIO.ISDK;
  // eslint-disable-next-line @typescript-eslint/ban-types
  let toggleRequestedCallback: Function | null;
  let clientId = 'unknow';

  // eslint-disable-next-line @typescript-eslint/ban-types
  function setToggleCallback(func: Function, force?: boolean) {
    if (force || !toggleRequestedCallback) {
      toggleRequestedCallback = func;
    }
  }

  async function initialize(authorizationKey: string) {
    if (!authorizationKey) {
      console.log(
        'Split is not connected, please provide an authorization key'
      );
      return;
    }

    if (client) {
      console.log('Client is already initialized');
      return;
    }

    try {
      factory = await SplitFactory({
        core: {
          authorizationKey,
          key: clientId,
        },
      });

      const instance = factory.client();

      await instance.ready();
      client = instance;
    } catch (error) {
      console.log('Error initializing SplitIO: ', error);
    }

    return;
  }

  function getToggle(
    treatment: TREATMENTS,
    attributes: Record<
      string,
      string | number | boolean | Array<string | number>
    >,
    defaultValue = false
  ) {
    if (!client) {
      return {
        isEnabled: () => defaultValue,
        getValue: () => null,
      };
    }

    const treatmentValue = isServer
      ? client.getTreatment(clientId, treatment, attributes)
      : client.getTreatment(treatment, attributes);

    if (toggleRequestedCallback)
      toggleRequestedCallback({ name: treatment, value: treatmentValue });

    return {
      isEnabled: () => treatmentValue === 'on',
      getValue: () => treatmentValue,
    };
  }

  function setClientId(id: string) {
    if (clientId === 'unknow') {
      clientId = id;
    }
  }

  return { initialize, getToggle, client, setClientId, setToggleCallback };
})();
